import config from '../../../../application/config/config';
import { loadData } from '../Util/List/CustomList/loadData';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { useState } from 'react';

const statusOptions = [{ label: 'Ativo', value: '1' }, { label: 'Inativo', value: '0' }];

function List() {
    const [values, setValues] = useState({ status: '1' });

    const pathFrontEnd = '/core/loginconfigs/';

    const paths = {
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'core/applicationsinstances/getall',
    };

    const handleChange = (form) => {
        const name = form['target']['name'];
        const value = form['target']['value'];

        setValues(prev => ({ ...prev, [name]: value }));
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                handleChange,
                isClearable: true,
                options: statusOptions,
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            }
        ],
        values: { ...values },
    };

    const list = {
        labelTitle: 'Lista de Instalações - Configuração de Login',
        labelTitleButtonAdd: 'Nova instalação',
        fieldsShowOnDelete: ['instance_name'],
        showPrintButtons: false,
        canDelete: false,
        canAdd: false,
        formFilters: filters,
        filter: {
            canListAll: true
        },
        columns: [
            {
                name: 'instance_name',
                label: 'Instalação',
                width: '20%'
            }
        ],
        ...paths,
    };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={null}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
